import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button, Chip, IconButton
} from '@mui/material';
import {
  DriveFileMove as DriveFileMoveIcon, Close as CloseIcon
} from '@mui/icons-material';
import FolderTreeView from './FolderTreeView';

const FolderDialog = ({ 
  open, 
  onClose, 
  tableTitle, 
  folderOptions, 
  selectedFolders, 
  setSelectedFolders 
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        elevation: 24,
        sx: {
          maxHeight: '80vh',
          borderRadius: 2,
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle sx={{ 
        borderBottom: '1px solid #e0e0e0',
        background: 'linear-gradient(to right, #f7f9fc, #edf2f7)',
        py: 2,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5
      }}>
        <DriveFileMoveIcon color="primary" />
        <Typography variant="h6" component="span">Tabloyu Klasöre Kaydet</Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ 
          p: 2, 
          mb: 3, 
          borderRadius: 1, 
          bgcolor: 'info.light', 
          color: 'info.contrastText' 
        }}>
          <Typography variant="body2">
            "{tableTitle}" tablosunu kaydetmek istediğiniz klasör(ler)i seçin
          </Typography>
        </Box>
        
        {selectedFolders && selectedFolders.length > 0 && (
          <Box sx={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: 1, 
            mb: 3, 
            p: 2,
            borderRadius: 1,
            border: '1px dashed',
            borderColor: 'primary.main',
            bgcolor: 'rgba(25, 118, 210, 0.05)'
          }}>
            <Typography variant="subtitle2" sx={{ width: '100%', mb: 1 }}>
              Seçili Klasörler ({selectedFolders.length})
            </Typography>
            {selectedFolders.map(folderId => {
              const folder = folderOptions.find(opt => opt.value === folderId) || 
                            (folderId === '0' ? { label: 'Ana Klasör', value: '0' } : null);
              return folder ? (
                <Chip 
                  key={folderId}
                  label={folder.label}
                  deleteIcon={<CloseIcon fontSize="small" />}
                  onDelete={() => setSelectedFolders(prev => prev.filter(id => id !== folderId))}
                  sx={{
                    fontWeight: 500,
                    bgcolor: 'background.paper',
                    '&:hover': {
                      bgcolor: 'background.default',
                    },
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                  }}
                />
              ) : null;
            })}
          </Box>
        )}
        
        <FolderTreeView 
          folderOptions={folderOptions} 
          selectedFolders={selectedFolders}
          setSelectedFolders={setSelectedFolders}
        />
      </DialogContent>
      <DialogActions sx={{ 
        borderTop: '1px solid #e0e0e0',
        p: 2.5,
        bgcolor: '#f9fafc'
      }}>
        <Button 
          onClick={onClose} 
          variant="outlined"
          sx={{ px: 2 }}
        >
          İptal
        </Button>
        <Button 
          onClick={onClose} 
          variant="contained" 
          color="primary"
          sx={{ px: 3 }}
        >
          Tamam
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FolderDialog;
